import { CheckCircle2, FileText, MessageSquareText, Sparkles } from 'lucide-react'
import { Link } from 'react-router-dom'
import StudentBackButton from '../components/StudentBackButton.jsx'
import { useLanguage } from '../contexts/LanguageContext.jsx'

const copy = {
  zh: {
    eyebrow: '面试准备',
    title: '把项目和成长记录整理成面试表达',
    desc: '围绕学习、练习、项目和成长记录，先准备能讲清楚的自我介绍、项目问题和 HR 问题。',
    growth: '我的成长',
    projects: '成果库',
    cards: [
      { title: '自我介绍', items: ['目标岗位和选择原因', '一个最能证明能力的项目', '当前正在补强的能力'] },
      { title: '项目追问', items: ['问题背景', '你的职责', '技术或方案选择', '结果与复盘'] },
      { title: 'HR 常见问题', items: ['为什么选择这个方向？', '如何处理压力？', '最近学到了什么？'] },
    ],
  },
  en: {
    eyebrow: 'Interview prep',
    title: 'Turn projects and growth records into interview talking points',
    desc: 'Prepare a clear self-introduction, project answers, and HR answers from learning, practice, projects, and growth records.',
    growth: 'My growth',
    projects: 'Outcome library',
    cards: [
      { title: 'Self introduction', items: ['Target role and motivation', 'One strongest project example', 'Current learning focus'] },
      { title: 'Project questions', items: ['Problem background', 'Your responsibility', 'Technical choices', 'Result and reflection'] },
      { title: 'HR questions', items: ['Why this role?', 'How do you handle pressure?', 'What did you learn recently?'] },
    ],
  },
}

export default function StudentInterviewPackPage() {
  const { language } = useLanguage()
  const t = copy[language] || copy.zh

  return (
    <main className="page-container interview-pack-page">
      <StudentBackButton />
      <section className="student-hero">
        <span><MessageSquareText size={16} /> {t.eyebrow}</span>
        <h1>{t.title}</h1>
        <p>{t.desc}</p>
        <div className="student-section-actions">
          <Link className="primary-button" to="/growth"><CheckCircle2 size={16} /> {t.growth}</Link>
          <Link className="secondary-button" to="/projects"><FileText size={16} /> {t.projects}</Link>
        </div>
      </section>
      <section className="interview-pack-grid">
        {t.cards.map((card) => (
          <article className="interview-pack-card" key={card.title}>
            <h2><Sparkles size={18} /> {card.title}</h2>
            <ul>{card.items.map((item) => <li key={item}>{item}</li>)}</ul>
          </article>
        ))}
      </section>
    </main>
  )
}
